import { LayoutDashboard, Package, FileCheck, Wallet, Settings } from "lucide-react";
import DashboardShell from "@/components/DashboardShell";
import { useAuth } from "@/context/AuthContext";
import ApplicationStatus from "@/pages/driver/ApplicationStatus";

const NAV = [
  { label: "Overview", to: "/driver", icon: LayoutDashboard, end: true },
  { label: "Deliveries", to: "/driver/deliveries", icon: Package },
  { label: "Documents", to: "/driver/documents", icon: FileCheck },
  { label: "Earnings", to: "/driver/earnings", icon: Wallet },
  { label: "Profile", to: "/driver/profile", icon: Settings },
];

export default function DriverLayout() {
  const { user } = useAuth();
  if (user?.driver_status !== "approved") {
    return <ApplicationStatus />;
  }
  return <DashboardShell roleTag="Driver Portal" navItems={NAV} />;
}
